import React, { useCallback, useEffect, useState } from "react";
import FormInput from "components/atoms/FormInput";
import PageTitle from "components/atoms/PageTitle";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "components/atoms/Alert";
import { getValues } from "services/storage";
import Dropzone from "components/atoms/Dropzone";
import DropzoneIcon from "../../../assets/svg/folder.svg";
import Button from "components/atoms/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import { SET_COUNTRIES } from "redux/app/app.type";
import axios from "services/axios";
import {
  getRequest,
  BASE_URL,
  putRequest,
  loggedUser_baseURL,
} from "services/http";
import KYCForms from "modules/kycForms";
import { updateSupportMail, updateBusinessMail, updateChargeBackMail } from "redux/formAction";
import { setUserLoggedIn } from "redux/auth/auth.action";
import returnIcon from "../../../assets/svg/arrow-left.svg";

const EMAILInformation = (props) => {
  const [loading, setLoading] = useState(false);
  const{form} = useSelector((state:any)=>state)
  const [businessEmail, setBusinessEmail] = useState(form.businessEmail || "");
  const [supportEmail, setSupportEmail] = useState(form.supportEmail || "");
  const [chargeBackEmail, setChargeBackEmail] = useState(form.chargeBackEmail || "");

  const navigate = useNavigate();
  const location: any = useLocation();
  const dispatch = useDispatch()

  const profileStatus_settlement =
    location?.state?.profileStatus?.step1 === "COMPLETED" ? true : false;

  const formComplete =
    businessEmail !== "" || supportEmail !== "" || chargeBackEmail !== "";
  const disabledBtn = !formComplete || loading;
  
  const dispatchToStore = useCallback(() => {
    dispatch(updateBusinessMail(businessEmail));
    dispatch(updateChargeBackMail(chargeBackEmail));
    dispatch(updateSupportMail(supportEmail));
  },[dispatch, businessEmail, chargeBackEmail, supportEmail])

  useEffect(()=>{
    dispatchToStore()
  },[dispatchToStore])


  const goToNext = () => {
    // dispatchToStore()
    if (profileStatus_settlement) {
      props.setUserLoggedIn(true);
    } else {
      navigate("/auth/settlement_info", {
        state: {
          ...location?.state,
          emails: {
            businessEmail,
            supportEmail,
            chargeBackEmail,
          },
        },
      });
    }
  };

  const verifyKYCandEmails = async (requestData: any) => {
    setLoading(true);
    const res = await putRequest(
      `${BASE_URL + loggedUser_baseURL}update`,
      {
        "Content-Type": "application/json",
        Authorization: `Bearer ${props.bearerToken}`,
      },
      requestData
    );

    if (res?.data.responseCode === "00") {
      Alert("success", res?.data.message);
      props.setUserLoggedIn(true);
    } else {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (businessEmail !== "" || supportEmail !== "" || chargeBackEmail !== "") {
      if (profileStatus_settlement) {
        verifyKYCandEmails({
          emails: {
            businessEmail,
            supportEmail,
            chargeBackEmail,
          },
        });
      } else {
        goToNext();
      }
    } else {
      return Alert("warning", `Please fill all required fields or skip`);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full max-w-sm gap-5"
    >
      <div className="flex flex-col gap-0">
        <span
          className="flex items-center gap-1 text-sm font-normal cursor-pointer"
          onClick={() => navigate("/auth/kyc_info")}
        >
          <img src={returnIcon} alt="return" className="w-[10px] h-[10px]" />
          Back``````````
        </span>
        <PageTitle
          pageTitle="Enter Email Information"
          pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
          subTitle="Fill in your email information"
          subTitleStyle="!text-sm leading-5 !text-Black2"
          style="!mb-0 !pb-0"
        />
      </div>
      <div className="flex flex-col gap-3">
        <span className="text-sm font-semibold">
          <span className="!text-[10px]">Required</span>
          <span style={{ color: "rgb(255 34 0)" }} className="font-16">
            *
          </span>
        </span>
        <div className="flex flex-col gap-3 mt-5">
          <FormInput
            type={"email"}
            name="businessEmail"
            placeholder="Enter Business Email"
            style="w-full"
            inputStyle="border border-transparent text-Black2"
            required={true}
            label="Business Email"
            labelStyle="font-semibold text-sm leading-6 text-Black2"
            value={businessEmail}
            onChange={(e) => {setBusinessEmail(e.target.value)}}
          />
          <FormInput
            type={"email"}
            name="supportEmail"
            placeholder="Support Email"
            style="w-full"
            inputStyle="border border-transparent text-Black2"
            required={true}
            label="Support Email"
            labelStyle="font-semibold text-sm leading-6 text-Black2"
            value={supportEmail}
            onChange={(e) => {setSupportEmail(e.target.value)}}
          />

          <FormInput
            type={"email"}
            name="chargeBackl"
            placeholder="Enter Charge Back Email"
            style="w-full"
            inputStyle="border border-transparent text-Black2"
            required={true}
            label="Charge Back Email"
            labelStyle="font-semibold text-sm leading-6 text-Black2"
            value={chargeBackEmail}
            onChange={(e) => {setChargeBackEmail(e.target.value)}}
          />
        </div>
      </div>

      <div className="flex justify-between">
        <button
          onClick={goToNext}
          className="p-3 text-red-500 border-none rounded-md bg-none"
        >
          Skip
        </button>
        <Button
          btnType="submit"
          btnText={
            loading
              ? "Loading..."
              : `${profileStatus_settlement ? "Submit" : "Next"}`
          }
          btnStyle={`${
            disabledBtn ? "cursor-not-allowed" : ""
          } bg-black text-white px-6 py-3 w-fit`}
          onClick={() => {}}
        />
      </div>
    </form>
  );
};

const mapStateToProps = (state: any) => ({
  user_authData: state.auth.user_authData,
  bearerToken: state.auth.user_authData?.token.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EMAILInformation);
